"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_DECIMAL_PLACES = void 0;
exports.DEFAULT_DECIMAL_PLACES = 2;
